export const NOTIFICATION_COUNT_UPDATED = 'NOTIFICATION_COUNT_UPDATED';
export default NOTIFICATION_COUNT_UPDATED;
